//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('serviceObjectTypeMenu', {
//        templateUrl: 'views/components/views/serviceObjectTypeMenu/serviceObjectTypeMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'serviceObjectTypeMenuService', function ($stateParams, serviceObjectTypeMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let serviceObjectTypeKeyno = $stateParams.serviceobjecttype_keyno;
            
//            vm.model = {
//                menu: {}
//            };

//            // #region VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            let loadMenu = function () {
//                serviceObjectTypeMenuService.getMenu({ serviceobjecttype_keyno: serviceObjectTypeKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.menu);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
